import React, { Component } from "react";
import ItemSummaryPanelView from "presentational/upload/ItemSummaryPanelView";
import LoadingModalView from "presentational/common/modals/LoadingModalView";
import { withStore } from "store/storeHandler";
import { uploadImage } from "lib/imageUploadHelper";
import { withToken } from "lib/forceTokenRenewComponent";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

class ItemSummaryPanel extends Component {
  static propTypes = {
    imageDataURL: PropTypes.string.isRequired,
    itemInfo: PropTypes.shape({
      category: PropTypes.string.isRequired,
      brand: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      tag: PropTypes.string.isRequired
    }).isRequired,
    onBackClick: PropTypes.func.isRequired,
    onUploadComplete: PropTypes.func.isRequired
  };

  state = {
    isUploading: false
  };

  getItemInfoObj = () => {
    const { itemInfo } = this.props;
    const { category, brand, color, tag } = itemInfo;

    const returnObj = { category, brand };

    if (color !== "") returnObj.color = color;

    const tempTag = tag.trim();
    if (tempTag !== "") returnObj.tag = tempTag.split(" ");

    return returnObj;
  };

  displayNotice(type) {
    const { NoticeModalActions } = this.props;
    let content;
    switch (type) {
      case "nullInput":
        content = <TXT name="msg_enterCatAndBrand" />;
        break;
      case "defaultUploadError":
      default:
        content = <TXT name="msg_commonNetworkError" />;
        break;
    }
    NoticeModalActions.openModal({ content });
  }

  handleSubmitClick = async () => {
    const {
      itemInfo,
      onUploadComplete,
      imageDataURL,
      MyItemActions,
      forceRenewTokenWT,
      AppErrorActions,
      getIdTokenWT
    } = this.props;
    const { isUploading } = this.state;
    const { category, brand } = itemInfo;

    if (!category || !brand) {
      this.displayNotice("nullInput");
      AppErrorActions.setSafeAppError(
        Error(`null input => category: "${category}", brand: "${brand}"`)
      );
      return null;
    }

    if (isUploading) return null;

    await this.setState({ isUploading: true });

    const hasSucceed = await forceRenewTokenWT();
    if (!hasSucceed) {
      this.setState({ isUploading: false });
      return null;
    }

    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) {
      this.setState({ isUploading: false });
      return null;
    }

    let filename;
    try {
      filename = await uploadImage("item", imageDataURL, idToken);
    } catch (error) {
      this.setState({ isUploading: false });
      this.displayNotice("defaultUploadError");
      AppErrorActions.setSafeAppError(error);
      return null;
    }

    try {
      await MyItemActions.uploadItem({
        filename,
        itemInfo: this.getItemInfoObj(),
        idToken
      });
    } catch (error) {
      AppErrorActions.setSafeAppError(
        Error(`rollback problem => unlinkedItemImageFile: "${filename}"`)
      );
      AppErrorActions.setFatalAppError(error);
      this.setState({ isUploading: false });
      return null;
    }

    this.setState({ isUploading: false });
    MyItemActions.deleteAllData();
    MyItemActions.setRealtimeDataOnNextRequest();
    onUploadComplete();
  };

  render() {
    const { imageDataURL, itemInfo, onBackClick } = this.props;
    const { isUploading } = this.state;

    return (
      <div>
        <ItemSummaryPanelView
          imageDataURL={imageDataURL}
          itemInfo={itemInfo}
          onBackClick={onBackClick}
          onSubmit={this.handleSubmitClick}
        />
        <LoadingModalView open={isUploading} />
      </div>
    );
  }
}

export default withStore({
  dispatchMap: ["myItem", "appError", "noticeModal"]
})(withToken(ItemSummaryPanel));
